<footer class="app-footer" aria-label="Application footer">
  <div class="footer-copy">
    <span class="footer-brand">SV</span>
    <span>&copy; {{ currentYear }} SV Infotech</span>
  </div>

  <div class="footer-credit">
    <span>Powered by</span>
    <strong>SV Infotech</strong>
  </div>
</footer>